import React, { memo } from 'react';
import {
  Timer,
  VisualNumber,
  TitleContainer,
  Title,
  Description,
  ContentContainer,
  Messages,
  InfoMessage,
  ErrorMessage,
  Media,
  AnswerContainer
} from 'app/pages/Survey/Subject/elements';
import ChoiceMultiLabel from './Label';
import Answer from './Answer';

function ChoiceMulti() {
  return (
    <>
      <Timer />
      <VisualNumber />
      <TitleContainer>
        <Title>
          <ChoiceMultiLabel />
        </Title>
        <Description />
      </TitleContainer>
      <ContentContainer>
        <Messages>
          <InfoMessage />
          <ErrorMessage />
        </Messages>
        <Media />
        <AnswerContainer>
          <Answer />
        </AnswerContainer>
      </ContentContainer>
    </>
  );
}

export default memo(ChoiceMulti);
